module.exports = __webpack_public_path__ + "static/img/23-leadershipinn.726ac1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-leadershipinn.png
// module id = ImoO
// module chunks = 1